@if (!loading) {
  @if (hasTitle) {
    <div class="block__title" [class.block__title--border]="titleBorder">
      <div class="block__title__container" [class.block__title__container--full-width]="fullWidthTitle()">
        <div class="block__title__text">
          <ng-content select="block-title"></ng-content>
        </div>
        <!--/block__title__text-->
      </div>
      @if (labeledTabs > 0 && tabStyle === 'default') {
        <div class="block__title__tabs" aria-role="tablist">
          <ng-content select="block-tabs"></ng-content>
          @if (isMobile() && viewTabs && currentViewTabs > 0) {
            <button class="navigation__icon" (click)="navigateTabs(-1)" htm-button theme="icon" data-test-id="title-tabs-previous-tab-button">
              <icon glyph="chevron-left"></icon>
            </button>
          }
          @for (tab of viewTabs[currentViewTabs]; track tab) {
            @if (tab.tabVisible) {
              @if (!tab.tabLink) {
                <button
                  (click)="selectTab(tab)"
                  ripple="dark"
                  role="tab"
                  [class.active]="tab.tabLabel == activeTab"
                  [attr.data-test-id]="'title-tabs-tab-button-' + (tab?.tabLabel | slugify)"
                  [attr.aria-selected]="tab.tabLabel === activeTab">
                  <span class="button__contents">
                    @if (tab.tabIcon) {
                      <icon size="medium" [glyph]="tab.tabIcon"></icon>
                    }
                    {{ tab.tabLabel }}
                  </span>
                  <!--/button__contents-->
                </button>
              }
              @if (tab.tabLink) {
                <button
                  (click)="navigateTo(tab.tabLink, tab.queryParams)"
                  ripple="dark"
                  [class.active]="tab.tabLabel == activeTab"
                  [attr.data-test-id]="'title-tabs-tab-button-' + (tab?.tabLabel | slugify)"
                  [attr.aria-selected]="tab.tabLabel === activeTab"
                  role="tab">
                  <span class="button__contents">
                    @if (tab.tabIcon) {
                      <icon size="medium" [glyph]="tab.tabIcon"></icon>
                    }
                    {{ tab.tabLabel }}
                  </span><!--/button__contents-->
                </button>
              }
            }
          }
          @if (isMobile() && viewTabs && viewTabs[currentViewTabs + 1]) {
            <button class="navigation__icon" (click)="navigateTabs(1)" htm-button theme="icon" data-test-id="title-tabs-next-tab-button">
              <icon glyph="chevron-right"></icon>
            </button>
          }
        </div>
      }
      <!--/block__title__Tabs-->
    </div>
  }
  <ng-content select="block-sub-title"></ng-content>
  <!--/title-area-->
  @if (hasSecondaryTitle) {
    <h2 class="block__title__secondary__text">
      <ng-content select="block-secondary-title"></ng-content>
    </h2>
  }
  <ng-content select="block-secondary-title-subtext"></ng-content>
  @if (labeledTabs > 0 && tabStyle === 'middle') {
    <div class="block__title__middle-tabs" role="tablist">
      <ng-content select="block-tabs"></ng-content>
      @if (isMobile() && viewTabs && currentViewTabs > 0) {
        <button class="navigation__icon" (click)="navigateTabs(-1)" htm-button theme="icon" data-test-id="middle-tabs-previous-tab-button">
          <icon glyph="chevron-left"></icon>
        </button>
      }
      @for (tab of viewTabs[currentViewTabs]; track tab) {
        @if (tab.tabVisible) {
          @if (tab.tabLink) {
            <button
              (click)="selectTab(tab)"
              [routerLink]="tab.tabLink"
              ripple="dark"
              [class.active]="tab.tabLabel == activeTab"
              [attr.aria-label]="tab.tabLabel == activeTab ? tab.tabLabel + ' ' + 'active' : ''"
              [attr.data-test-id]="'middle-tabs-tab-button-' + (tab?.tabLabel | slugify)"
              [attr.aria-selected]="tab.tabLabel === activeTab"
              role="tab"
              >
              <span class="button__contents">
                @if (tab.tabIcon) {
                  <icon [glyph]="tab.tabIcon"></icon>
                }
                @if (!tab.tabHeading) {
                  <div class="title">{{ tab.tabLabel }}</div>
                }
                @if (tab.tabHeading) {
                  <h2>{{tab.tabLabel | translate}}</h2>
                }
              </span>
              <!--/button__contents-->
            </button>
          }
          @if (!tab.tabLink) {
            <button
              (click)="selectTab(tab)"
              ripple="dark"
              [class.active]="tab.tabLabel == activeTab"
              [attr.data-test-id]="'middle-tabs-tab-button-' + (tab?.tabLabel | slugify)"
              [attr.aria-selected]="tab.tabLabel === activeTab"
              role="tab"
              >
              <span class="button__contents">
                @if (tab.tabIcon) {
                  <icon [glyph]="tab.tabIcon"></icon>
                }
                <div class="title">{{ tab.tabLabel | translate }}</div>
              </span>
              <!--/button__contents-->
            </button>
          }
        }
      }
      @if (isMobile() && viewTabs && viewTabs[currentViewTabs + 1]) {
        <button class="navigation__icon" (click)="navigateTabs(1)" htm-button theme="icon" data-test-id="middle-tabs-next-tab-button">
          <icon glyph="chevron-right"></icon>
        </button>
      }
    </div>
  }
  <!--/block__title__middle-tabs-->
  <!--/block__title__middle__text-->
  <ng-content select="block-content"></ng-content>
}

@if (loading) {
  <div class="block__content">
    <skeleton type="article"></skeleton>
  </div><!--/block__content-->
}
